




























import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleUserActive: 'The Newest Notifications',
      alignCard: 'center',
      fieldsUserActive: [
        { key: 'no' },
        { key: 'file_type' },
        { key: 'title' },
        { key: 'created_date' },
        { key: 'total_assignment' },
        { key: 'total_user_access' },
        { key: 'total_visit' },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
}
